import React from 'react';
import Quiz from './Quiz';
import { useAdminQuizMutation, useAdminQuizQuery } from '../../../apis/quiz';

const stateCardClasses =
  'max-w-3xl mx-auto rounded border bg-white p-6 shadow-sm text-left';

const AdminQuizPage = ({
  moduleKey,
  title = 'End of Module Quiz',
  introContent = null,
  pdfSrc,
  pdfText,
}) => {
  const {
    data: quizData = [],
    isLoading,
    isError,
  } = useAdminQuizQuery(moduleKey);
  const submitQuizMutation = useAdminQuizMutation();

  if (isLoading) {
    return (
      <div className={stateCardClasses}>
        <p className='text-xl font-bold'>Loading quiz...</p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className={stateCardClasses}>
        <p className='text-xl font-bold'>We could not load this quiz.</p>
        <p className='mt-2 text-base'>
          Please refresh the page or try again in a moment.
        </p>
      </div>
    );
  }

  if (!quizData.length) {
    return (
      <div className={stateCardClasses}>
        <p className='text-xl font-bold'>No quiz questions are available yet.</p>
      </div>
    );
  }

  return (
    <Quiz
      moduleKey={moduleKey}
      title={title}
      introContent={introContent}
      quizData={quizData}
      pdfSrc={pdfSrc}
      pdfText={pdfText}
      onSubmitQuiz={submitQuizMutation.mutate}
    />
  );
};

export default AdminQuizPage;
